import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { InteractiveMapApp } from '../views';
import interactiveMapConfig from './InteractiveMapConfig';
import i18n from '../i18n';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

createApp(InteractiveMapApp, interactiveMapConfig)
  .use(pinia)
  .use(i18n)
  .mount('#calmac-interactive-map');
